





























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { orderSendOutList, modifyLogistics, getLogisticsCom } from '../../utils/api';
import fuzzySearch from './common/fuzzySearch.vue';
import tableEmpty from '@/components/empty/tableEmpty.vue';
interface searchItem {
  value: string;
  code: string;
}
@Component({ components: { fuzzySearch, tableEmpty } })
export default class order_send_out extends Vue {
  currentPage = 1;
  pagesize = 10;
  totalElements = 0;
  dataList: any = [];
  resetData: any = {
    consigneeName: '',
    consigneeMobile: '',
    logisticsNo: '',
  };
  data = {
    page: 0,
    size: this.pagesize,
    consigneeMobile: '',
    consigneeName: '',
    logisticsNo: '',
    supplierId: '',
    partnerId: '',
  };
  loading = true;
  searchItem: searchItem = {
    value: '',
    code: '',
  };
  drawer: boolean = false; //改物流抽屉
  //改物流表单
  logisticsForm: any = {
    logisticsNo: '',
    logisticsCompanyName: '',
    newLogisticsNo: '',
    newCompanyName: '',
    newCompanyCode: '',
  };
  performanceOrderId: string = ''; //发货单号
  logisticsCompanyInfo:any =[] //物流公司列表
  rules: object = {
    newLogisticsNo: [{ required: true, message: '请输入修改后单号', trigger: ['blur', 'change'] }],
    newCompanyName: [{ required: true, message: '请选择修改后物流公司', trigger: ['change'] }],
  };
  mounted() {
    this.getDataList(this.data);
  }
  // 收集模糊搜索商家名称
  fuzzySearchValue(item) {
    this.searchItem = item;
    this.data.partnerId = item.code;
  }
  //获取数据
  async getDataList(data) {
    try {
      const result = await orderSendOutList(data);
      this.dataList = result['content'];
      this.totalElements = result['totalElements'];
      this.loading = false;
    } catch (error) {
      this.$message.error(error);
      this.loading = false;
    }
  }
  //分页
  async handleCurrentChange(val) {
    try {
      this.data.page = val - 1;
      await this.getDataList(this.data);
    } catch (error) {}
  }
  //跳转发货单详情
  handleClick(row) {
    this.$router.push(`send_out_detailed?orderId=${row.orderId}&performanceOrderId=${row.performanceOrderId}`);
  }
  //查询
  search() {
    this.data.consigneeMobile = this.data.consigneeMobile.trim();
    this.data.consigneeName = this.data.consigneeName.trim();
    this.data.logisticsNo = this.data.logisticsNo.trim();
    this.data.page = 0;
    this.currentPage = this.data.page + 1;
    this.getDataList(this.data);
  }
  //清空
  reset() {
    this.data = {
      page: 0,
      size: this.pagesize,
      consigneeMobile: '',
      consigneeName: '',
      logisticsNo: '',
      supplierId: '',
      partnerId: '',
    };
    // 重置模糊搜索输入框
    Object.assign((this as any).$data.searchItem, (this as any).$options.data['call'](this).searchItem);
    this.getDataList(this.data);
  }

  //改物流
  changeLogistics(row) {
    console.log(row);
    this.logisticsForm.newLogisticsNo = ''; //清除缓存
    this.logisticsForm.newCompanyName = ''; //清除缓存
    this.drawer = true;
    this.logisticsForm = row;
    this.performanceOrderId = row.performanceOrderId;
    //查询物流列表
    getLogisticsCom()
      .then((res) => {
       console.log(res);  
       this.logisticsCompanyInfo = res;
      })
      .catch((error) => {
        this.$message.error(error);
      });
  }
  //下拉框数据收集
  getValue(val) {
    console.log(val);
    this.logisticsForm.newCompanyName = val.split('/')[0];
    this.logisticsForm.newCompanyCode = val.split('/')[1];
  }
  //修改物流表单确认
  changeConfirm(logisticsForm) {
    (this as any).$refs[logisticsForm].validate((valid) => {
      if (valid) {
        let data = {
          newCompanyCode: this.logisticsForm.newCompanyCode,
          newCompanyName: this.logisticsForm.newCompanyName,
          newLogisticsNo: this.logisticsForm.newLogisticsNo,
          performanceOrderId: this.performanceOrderId,
        };
        modifyLogistics(data)
          .then((res) => {
            this.$message({
              message: '修改物流成功',
              type: 'success',
            });
            this.drawer = false;
            this.getDataList(this.data); //更新发货单信息
          })
          .catch((error) => {
            this.$message.error(error);
          });
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  // 取消修改物流表单
  cancel() {
    this.drawer = false;
  }
}
